import type { ReactNode } from "react";
import { StatusChip } from "@/shared/ui/status";
import { isDatasetHidden, type Dataset } from "../../domain/dataset";
import type { Probe } from "../../domain/probe";
import { probeStatusView } from "../../feature/probeStatus";
import styles from "./datasetDetailBadge.module.css";

/**
 * 제목 옆 읽기 전용 배지 — 이 창이 **무엇을 보고 있는지**에 붙는 상태만 든다(누를 수 있는 것은
 * `DatasetDetailActions` 다). 섹션 탭은 라벨만 들므로 Probe 상태는 여기 한 자리에서 읽힌다.
 *
 * 컴포넌트가 아니라 함수인 것이 계약이다 — 배지가 없을 때 호출부가 셸 슬롯에 `null` 을 넣어야
 * 셸이 빈 래퍼를 그리지 않는다.
 */
export function datasetDetailTitleBadge(
  dataset: Dataset | null,
  probe: Probe | null,
): ReactNode | null {
  const hidden = dataset !== null && isDatasetHidden(dataset);
  const status = probe === null ? null : probeStatusView(probe.state);
  if (!hidden && status === null) {
    return null;
  }
  return (
    <span className={styles.badges}>
      {hidden ? <StatusChip tone="muted">숨김</StatusChip> : null}
      {status === null ? null : <StatusChip tone={status.tone}>{status.label}</StatusChip>}
    </span>
  );
}
